import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=b6b06e0c&scoped=true&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=b6b06e0c&prod&scoped=true&lang=css&"
import style1 from "./LeadDetails.vue?vue&type=style&index=1&id=b6b06e0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b06e0c",
  null
  
)

export default component.exports